import React from 'react'
import styled from 'styled-components'
import {Edit, Delete, Done, Close} from '@mui/icons-material'
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton'

const Option = styled.div`
    width: 100%;
    min-width: 400px;
    display: flex;
    align-items: center;
    padding: 10px;
    cursor: pointer;
    box-sizing: border-box;
    background: ${props => props.active ? 'rgb(240, 240, 240)' : '#FFFFFF'};
`

const Value = styled.div`
    margin-right: auto;
    color: ${props => props.active ? '#415dd4' : ''};
    white-space: pre-wrap;
    overflow-wrap: break-word;
`

const Field = styled(TextField)`
    width: 100%;
    margin-right: 30px;
`

class Signature extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            value: props.create ? '' : props.data.html,
            edit: props.create ? true : false
        }
    }

    handleClose = () => {
        if (this.props.create) {
            this.props.handleCancel()
        } else {
            this.setState({
                edit: false,
                value: this.props.data.html
            })
        }
    }

    handleEdit = (e) => {
        e.stopPropagation()

        this.setState({
            edit: true
        })
    }

    handleSelect = () => {
        this.props.handleSelect(this.props.data.id)
    }

    handleChange = (e) => {
        this.setState({
            value: e.target.value
        })
    }

    handleUpdate = () => {
        if (this.props.create) {
            this.props.createSignature({html: this.state.value, name: ''})
        } else {
            this.props.updateSignature({id: this.props.data.id, html: this.state.value, name: this.props.data.name})
            this.setState({
                edit: false
            })
        }
    }

    handleDelete = (e) => {
        e.stopPropagation()

        this.props.deleteSignature(this.props.data.id)
        this.setState({
            edit: false
        })
    }

    render() {
        return (
            <Option onClick={!this.state.edit ? this.handleSelect : undefined} active={this.props.active}>
                {this.state.edit ?
                    <Field variant="standard" onChange={this.handleChange} value={this.state.value} multiline /> :
                    <Value>
                        <span dangerouslySetInnerHTML={{ __html: this.props.data.html }} />
                    </Value>
                }
                {this.state.edit ?
                    <React.Fragment>
                        <IconButton disabled={this.state.value.replace(/\s/g, '') === ''} onClick={this.handleUpdate}>
                            <Done />
                        </IconButton>
                        <IconButton onClick={this.handleClose}>
                            <Close />
                        </IconButton>
                    </React.Fragment> :
                    <React.Fragment>
                        <IconButton onClick={this.handleEdit}>
                            <Edit />
                        </IconButton>
                        <IconButton disabled={this.props.active} color='secondary' onClick={this.handleDelete}>
                            <Delete />
                        </IconButton>
                    </React.Fragment>
                }
            </Option>
        )
    }
}

export default Signature
